import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiBaseUrl } from "network";

export const locationApi = createApi({
    reducerPath: "locationApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiBaseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        updatePop: builder.mutation({
            query: (body) => ({ url: "admin-location/makePop", method: "POST", body: body }),
        }),
        getAllLocation: builder.query({
            query: ({ page, limit, search }) => ({
                url: `admin-location/list?page=${page}&limit=${limit}&search=${search}`
            }),
            transformResponse: (response) => response.data
        }),
        addLocation: builder.mutation({
            query: (body) => ({ url: "admin-location/add", method: "POST", body: body }),
        }),
        updateLocation: builder.mutation({
            query: ({id,data}) => ({ url: `admin-location/edit/${id}`, method: "PUT", body: data }),
        }),
    })
})

export const { useUpdatePopMutation,useAddLocationMutation,useUpdateLocationMutation,useGetAllLocationQuery } = locationApi;
